module.exports = __webpack_public_path__ + "static/media/service_s2.152414c6.png";